// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"action_shadow__3HjZd","action":"action_action__2LF6c","button":"action_button__2Q9y5"};